import $ from 'jquery';


$.fn.nextElementInDom = function (selector, firstcall, commingup) {
    firstcall = firstcall && true;
    commingup = (commingup === 'undefined' ? false : commingup);
//    console.log('--------------------');
//    console.log(`NextElementInDom(${selector}, ${firstcall}, ${commingup}): `);
//    console.log('Aktuelles Element:');
//    console.log(this);
//    console.log('Fokussiertes Element:');
//    console.log($(':focus'));

    switch (true) {
        case (this.is(selector) && this.is(':visible')) && !firstcall && !commingup:
            // The current element is the one with the selector
//            console.log('Selektor gefunden, das Element ist sichtbar, es ist nicht der erste Aufruf und wir kommen nicht von den Kindern hoch');
            return this;
        case (!commingup && this.children(':first-child').length > 0):
            // Current element has children, so check them
//            console.log('PrÃ¼fe erstes Kindelement:');
//            console.log(this.children(':first-child'));
            return this.children(':first-child').nextElementInDom(selector, false);
        case (this.next().length > 0):
            // Search in the next sibling
//            console.log('PrÃ¼fe nÃ¤chstes Element:');
//            console.log(this.next());
            return this.next().nextElementInDom(selector, false);
        case this.parent().length > 0:
            // At this point we are at an ending branch, so we have to go up (parents)
            // as long as there will be new siblings
//            console.log('Kein Treffer gefunden, gehe weiter nach oben');
//            console.log(this.parent());
            return this.parent().nextElementInDom(selector, false, true);
        default:
            // Not found any hits, so start from the beginning
//            console.log('Keine Treffer gefunden, starte ganz von vorne, vom Body');
            return $('body').nextElementInDom(selector, false, false);
    }
};


// WEBPACK FOOTER //
// ./jquery/jquery.nextElementInDom.js